// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper[data-v-744405aa]{display:flex;flex-direction:column;min-height:100vh}.content[data-v-744405aa]{flex-grow:1;background:#131313}@media(max-width:992px){.wrapper[data-v-744405aa]{flex-direction:column}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
